@import '~less/global-variables';
@import '~less/bootstrap/legacy-mixins';

.leaflet-marker-icon:not(.no-anim),
.leaflet-marker-shadow:not(.no-anim),
.leaflet-markercluster-icon:not(.no-anim) {
  transition: @map-zoom-transition;
}
.leaflet-zoom-anim {
  .leaflet-zoom-animated {
    .leaflet-marker-icon:not(.no-anim),
    .leaflet-marker-shadow:not(.no-anim),
    .leaflet-markercluster-icon:not(.no-anim) {
      transition: @map-zoom-transition;
    }
  }
}
